export default __webpack_public_path__ + "static/media/s.a6123a7e.png";